export function shouldRemoveCSirianoFromColorCollection (_data = [], shouldRemove = true) {
  const data = _data ?? []
  return shouldRemove ? data.filter((item) => item.name.toLowerCase().indexOf('siriano') === -1) : data
}
